/**
 * Current legal/privacy consent version enforced by the Phoenix portal.
 *
 * MUST equal the main portal's `src/app/legal/privacy-consent/privacy-consent.version.ts`:
 * the consent record is TENANT-wide (one `TenantPrivacyConsent` row per tenant, written by
 * `POST /api/privacy-consent/accept` — the same endpoint both portals call), so a version
 * mismatch between the two apps would make one portal re-demand a consent the customer has
 * already given in the other. `consent-version-parity.spec.ts` pins the equality; bump BOTH
 * files together when the legal texts change.
 */
export const PRIVACY_CONSENT_VERSION = 'V.2026.01';
